export enum StorageKey {
  workCenterId = 'workCenterId',
  pileTurnerId = 'pileTurnerId',
  defaultLanguage = 'defaultLanguage'
}
